import { defineComponent as _defineComponent } from 'vue'
import { useDropzone } from "vue3-dropzone";
import Uuid from "../../module/common/models/Uuid";


export default /*@__PURE__*/_defineComponent({
  __name: 'dropzone',
  emits: ['file_accepted', 'file_loaded', 'file_load_error'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();


const emit = __emit
const on_drop = function (arg_accept_files, arg_reject_reasons) {
    for (let tmp_file of arg_accept_files) {
        const loc_file_id = new Uuid();
        console.log(arg_reject_reasons, 'arg_reject_reasons')
        emit('file_accepted', loc_file_id, tmp_file.name, tmp_file.type, tmp_file.size, tmp_file.lastModified);

        const loc_reader = new FileReader();
        loc_reader.onload = () => {
            emit('file_loaded', loc_file_id, loc_reader.result);
        };
        loc_reader.onerror = () => {
            emit('file_load_error', loc_reader.error);
        };
        loc_reader.readAsArrayBuffer(tmp_file);
    }
}

const { getRootProps: get_root_props, getInputProps: get_input_props, open: open } = useDropzone({ onDrop: on_drop });

     
  
const __returned__ = { emit, on_drop, get_root_props, get_input_props, open }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})